import React from 'react';
import { renderField } from './DynamicForm';

/**
 * ObjectField - Handles nested objects/embedded documents (recursive)
 * Example: { settings: { theme: 'dark', notifications: true } }
 * Also handles: { contacts: { primary: { name: 'John', email: 'john@example.com' } } }
 */
export const ObjectField = ({ field, value, onChange, error, depth = 0 }) => {
  const handleFieldChange = (fieldName, fieldValue) => {
    onChange({
      ...(value || {}),
      [fieldName]: fieldValue
    });
  };

  // If no nested schema defined, show JSON editor
  if (!field.fields || Object.keys(field.fields).length === 0) {
    return (
      <div className="form-field">
        <label>{field.label}</label>
        <textarea
          value={JSON.stringify(value || {}, null, 2)}
          onChange={(e) => {
            try {
              const parsed = JSON.parse(e.target.value);
              onChange(parsed);
            } catch (err) {
              // Invalid JSON, don't update
            }
          }}
          rows={6}
          className="json-textarea"
          placeholder="Enter valid JSON"
        />
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }

  // Render nested fields with proper depth styling
  const depthClass = `object-field-depth-${Math.min(depth, 3)}`;
  
  return (
    <div className={`object-field ${depthClass}`}>
      <h4 className="object-field-label">{field.label}</h4>
      <div className="object-field-content">
        {Object.entries(field.fields).map(([fieldName, fieldDef]) => (
          <div key={fieldName} className="nested-field">
            {renderField(
              fieldName,
              fieldDef,
              value?.[fieldName],
              (val) => handleFieldChange(fieldName, val),
              value,
              depth + 1  // Pass depth for recursive nesting
            )}
          </div>
        ))}
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default ObjectField;
